import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private readonly myKey = 'sY91Mztdb8VA+Hwb8DxIyrAPsNNwRvjQyyKkf05pwGnp2vkHyllqX8TRe2zsryjRDYm9O6FztjdwlITe9144fJgPYotF++q9Recp3KeMdB9js0GX8PfC8rZKgnlAQ/EUg6OhKUwNcZfo47ltI83craXH0ncB8Z8Mk08SNLkwuo6y5L3zrt5v6Bp/HMZozTU+DmG0LZ+SlVlJFy6fFwGZDQ';
  private readonly encryptSecretKey = 'sY91Mztdb8VA+Hwb';

  constructor() { }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.myKey).toString();
  }

  decrypt(value: string): string {
    return CryptoJS.AES.decrypt(value, this.myKey).toString(CryptoJS.enc.Utf8);
  }

  encryptToSend(msg: string): string {
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    var key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
        keySize: keySize / 32,
        iterations: 100
    });
    
    var iv = CryptoJS.lib.WordArray.random(128 / 8);
    
    var encrypted = CryptoJS.AES.encrypt(msg, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    
    var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    
    return result;
  }

  decryptToSend(ciphertextB64: string): string {
    var key = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);                             
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);  
 
    var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, {iv: iv}); 
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
